import { Component, Injectable, OnInit} from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService} from '../services/common.service';
declare let swal: any;
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  model: any = {};
  data:any={};
  select: any;
  selected_pck_type:any;
  entered:any;
  users :any= []; //storing the data from the API
  userRestApiUrl: string = AppSettings.Userlogin; //API common URL
  getpackagelistRestApiUrl:string = AppSettings.getPackageDetail; 
  CheckwebsiteExistsRestApiUrl:string = AppSettings.checkwebsitedetail; 
  checkUserRestApiUrl:string = AppSettings.checkuserdetail; 
  AddUserRestApiUrl:string = AppSettings.Adduser; 
  packagelist:Array<Object>;
  

 constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) {

    document.body.className="signup-page2";

   }


  ngOnInit() {
     this.entered = 0;
     this.model.passwordmatch=false;
      this.CommonService.getdata(this.getpackagelistRestApiUrl)
        .subscribe(packagedet =>{
            if(packagedet.result!="")
            { 
              this.packagelist= packagedet.result;
            } 
        });
        this.model.website=localStorage.getItem('website_name');

        let translate_url="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        this.loadScript(translate_url);
  }

  public loadScript(url) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

   passwordMatch()
   {
     this.model.passwordmatch=false;
     if((this.model.password!='')&&(this.model.confirmp!=''))
     {
        console.log(this.model);
       if(this.model.password!=this.model.confirmp)
       {
         this.model.passwordmatch = true;

       }
     }
   }
  adduser()
  {
    delete this.model.passwordmatch;
    delete this.model.confirmp;
    this.model.user_type=2;
    this.model.country="Turkey";
    this.model.gender="male";

    this.CommonService.insertdata(this.AddUserRestApiUrl,this.model)
    .subscribe(user_det =>{ 
      if(user_det.status=='fail')
      {
         swal(
          user_det.status,
          user_det.message,
          'error'
        )
         return false;
       }  
       else{
         swal(
          user_det.status,
          "AI Internet Created Successfully",
          'success'
        )
        this.router.navigate(['/login']); 
       }    
         
    });
  }
  checkUserexist(event:any)
  {
    //console.log(event.target.value);
    this.model.username=event.target.value;
    this.CommonService.checkexistdata(this.checkUserRestApiUrl,this.model)
    .subscribe(package_det =>{
      if(package_det.exist==1)
      {
        swal('',package_det.message,'error')
        this.model.username='';
      } 
      
    });
  }

  selectPackage(){
    this.model.website='';
    if(this.model.pcktaken!=""){
      this.model.filteredPackDetails=this.packagelist.filter((pckData: any) => pckData.id == this.model.pcktaken);
    this.model.selected_pck_type = this.model.filteredPackDetails[0].pck_type;
    if(this.model.selected_pck_type==4){
      this.model.selectedwebsite_prefix="p-"
    }
    else if(this.model.selected_pck_type==5){
      this.model.selectedwebsite_prefix="b-"
    }else{
      this.model.selectedwebsite_prefix="";
    }
    
    console.log("selectPackage",this.model.selected_pck_type);
    }
    
  }
   checkwebsite()
  {
    
    if(this.model.pcktaken=="" || this.model.pcktaken==undefined ){
      swal('','Select AI Type','error');
      this.model.website='';
    }else{
      this.CommonService.checkexistdata(this.CheckwebsiteExistsRestApiUrl,this.model)
    .subscribe(package_det =>{
      if(package_det.exist==1&& package_det.sale_status==0)
      {
        swal('',package_det.message,'error')
        this.model.website='';
      } 
      
       if(package_det.exist==1&& package_det.sale_status==1)
      {
        // Show confirmation dialog with Buy Now or Cancel options
        swal({
          title:"For Sale",
          text: package_det.internet_life_sale[0].website +" "+ package_det.message,
          icon: "info",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "",
              closeModal: true,
            },
            confirm: {
              text: "Buy Now",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            }
          },
          dangerMode: false,
        }).then((result) => {
          if (result) {
            // Redirect to buyinternetlife route with the website name
            const websiteName = package_det.internet_life_sale[0].website;
            this.router.navigate([`/buyinternetlife/${websiteName}`]);
          }else{
            this.model.website='';
          }
        });
      }
    });
    }
    
  }

}
